// Keep in sync with packages/store-datasource/src/sources/documentManifest/liveQuery.ts
export type DocumentManifestScopeOptions = {
  organisationTags?: string[];
  organisationNamePrefix?: string;
  organisationNames?: string[];
};

export const isDocumentManifestLiveQueryEnabled = (
  options?: DocumentManifestScopeOptions
): boolean =>
  !(
    !!options?.organisationTags?.length &&
    !options?.organisationNamePrefix &&
    !options?.organisationNames?.length
  );
